import { StackActions, useNavigation } from '@react-navigation/native';
import VehicleAddSection from 'components/account/vehicle/VehicleAddSection';
import SelectVehicleItem from 'components/park/SelectVehicleItem';
import AccountContext from 'context/AccountContext';
import useSelectedParkingVehicle from 'hooks/useSelectedParkingVehicle';
import { useContext } from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import { parkingVehicleLicensePlate } from 'states/common';
import { useParkingStore } from 'stores/parkingStore';
import { useVehicleStore } from 'stores/vehicleStore';
import { ColumnWithMargins } from 'styles/ContainerStyles';
import { Vehicle } from 'types/generatedSchemaTypes';
import { RootNavProps } from 'types/navigation';
import { testIdentifiers } from 'utils/testIdentifiers';
import { useUiStore } from 'stores/uiStore';

const SelectVehicleModalContent = () => {
  const { setParkingVehiclePlate } = useParkingStore((state) => state);
  const { navigate, dispatch } = useNavigation<RootNavProps>();
  const {
    customer: { vehicles },
  } = useContext(AccountContext);
  const selectedVehicle = useSelectedParkingVehicle();
  const { resetVehicleStore, setVehicleData } = useVehicleStore(
    (state) => state
  );
  const handleSetVehicle = (vehicle: Vehicle) => {
    // We have added state management to parking functionality to try to move away from using reactive vars
    // for a while we are using both approaches, since the reactive var is set in multiple places in the app
    parkingVehicleLicensePlate(vehicle?.licensePlate?.plateText);
    setParkingVehiclePlate(vehicle?.licensePlate?.plateText);
    useUiStore.getState().setSheetModal('');
  };
  const handleOnPress = () => {
    useUiStore.getState().setSheetModal('');
    resetVehicleStore();
    navigate('addVehicleParking');
  };

  const handleEditVehicle = (v: Vehicle) => {
    useUiStore.getState().setSheetModal('');
    resetVehicleStore();
    setVehicleData(v);
    dispatch(
      StackActions.push('mainTabs', {
        screen: 'accountScreen',
        params: {
          screen: 'editVehicle',
          params: {
            licensePlate: v.licensePlate?.plateText,
          },
        },
      })
    );
  };
  return (
    <ScrollView nestedScrollEnabled>
      {vehicles?.map((vehicle, index) => {
        return (
          <SelectVehicleItem
            editVehicle={handleEditVehicle}
            isSelected={
              selectedVehicle?.licensePlate?.plateText ===
              vehicle.licensePlate?.plateText
            }
            key={`${vehicle.licensePlate?.plateText}-${index}`}
            vehicle={vehicle}
            onPress={handleSetVehicle}
          />
        );
      })}
      <ColumnWithMargins
        mt={40}
        {...testIdentifiers('add-vehicle-list-item-button')}>
        <VehicleAddSection onPress={handleOnPress} style="BUTTON" />
      </ColumnWithMargins>
    </ScrollView>
  );
};

export default SelectVehicleModalContent;
